var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.11 28.336c-.201-.133-3.848-2.525-9.273-3.699 1.99-2.521 3.268-5.912 3.811-8.169.754-3.128.461-9.248-2.543-13.062C21.349 1.177 18.892 0 16 0s-5.349 1.178-7.104 3.406C5.892 7.219 5.6 13.339 6.353 16.467c.543 2.257 1.82 5.648 3.811 8.169-5.425 1.174-9.072 3.566-9.272 3.699A1.999 1.999 0 1 0 2 32h28a2.001 2.001 0 0 0 1.11-3.664zm-10.843-4.938-.326.414c-2.385 2.74-5.495 2.74-7.879 0l-.327-.414c-2.785-3.529-4.167-8.197-3.572-12.65C8.708 6.469 11.16 2 16 2s7.293 4.47 7.838 8.749c.593 4.455-.784 9.118-3.571 12.649zM2 30c.138-.092 3.526-2.314 8.586-3.408l2.484-.537c.887.582 1.86.945 2.93.945 1.071 0 2.043-.363 2.93-.945l2.484.537C26.434 27.678 29.81 29.875 30 30H2z"
  })));
};

export default SvgUser;